import { render } from "./Credit.vue?vue&type=template&id=795220be&scoped=true&ts=true"
import script from "./Credit.vue?vue&type=script&lang=ts"
export * from "./Credit.vue?vue&type=script&lang=ts"

import "./Credit.vue?vue&type=style&index=0&id=795220be&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795220be"]])

export default __exports__